import { useEffect, useState, useSyncExternalStore } from 'react';
import { authFetch } from '../../utils/api';
import { useViewScope } from '../../utils/viewScope';
import { NodeListSource } from './nodeListQuery';

export function useNodeList() {
  const { scope } = useViewScope();
  const [source] = useState(() => new NodeListSource(authFetch, scope));
  const snapshot = useSyncExternalStore(source.subscribe, source.getSnapshot);
  useEffect(() => {
    source.start(scope);
    return () => source.stop();
  }, [scope, source]);

  // Scope changes render before effects. Never expose even a single stale frame.
  const matchesScope = snapshot.query.scope === scope;
  return {
    ...snapshot,
    query: matchesScope ? snapshot.query : {
      ...snapshot.query, scope, page: 1, tierId: undefined,
    },
    list: matchesScope ? snapshot.list : [],
    total: matchesScope ? snapshot.total : 0,
    tiers: matchesScope ? snapshot.tiers : [],
    tiersReady: matchesScope && snapshot.tiersReady,
    loading: !matchesScope || snapshot.loading,
    error: matchesScope && snapshot.error,
    notice: matchesScope ? snapshot.notice : null,
    setQuery: (change: Parameters<NodeListSource['setQuery']>[0]) => source.setQuery({ ...change, scope }),
    refresh: source.refresh,
  };
}
